import qoalaStorage from '~/core/Storage';
import { parseIfJsonString } from '~/core/helper/JSONHelper';

export default {
  getData: state => state.lifeInsuranceData,
  getListProduct: state =>
    qoalaStorage.getItem('lifeInsuranceProduct')
      ? parseIfJsonString(qoalaStorage.getItem('lifeInsuranceProduct'))
      : state.listProduct,
  getProductDetail: state =>
    qoalaStorage.getItem('productDetailLife')
      ? parseIfJsonString(qoalaStorage.getItem('productDetailLife'))
      : state.productDetail
};
